/* tslint:disable */
import {
  Lease,
  UserProfile,
  TenantUnit,
  PropertyUnits,
  CompanyAccount,
  FileManager
} from '../index';

declare var Object: any;
export interface TenantLeaseInterface {
  "lease_id"?: number;
  "tenant_id": number;
  "tenant_type": string;
  "exit_step"?: number;
  "rejection_reason"?: string;
  "application_date"?: Date;
  "application_approval_date"?: Date;
  "exit_type"?: string;
  "exit_date"?: Date;
  "id"?: number;
  "property_unit_id"?: number;
  "property_id"?: number;
  "tenant_lease_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  lease?: Lease;
  tenant?: UserProfile;
  userProfile?: UserProfile;
  leaseUnit?: TenantUnit;
  tenantUnit?: TenantUnit;
  propertyUnit?: PropertyUnits;
  property?: CompanyAccount;
  files?: FileManager[];
}

export class TenantLease implements TenantLeaseInterface {
  "lease_id": number;
  "tenant_id": number;
  "tenant_type": string;
  "exit_step": number;
  "rejection_reason": string;
  "application_date": Date;
  "application_approval_date": Date;
  "exit_type": string;
  "exit_date": Date;
  "id": number;
  "property_unit_id": number;
  "property_id": number;
  "tenant_lease_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  lease: Lease;
  tenant: UserProfile;
  userProfile: UserProfile;
  leaseUnit: TenantUnit;
  tenantUnit: TenantUnit;
  propertyUnit: PropertyUnits;
  property: CompanyAccount;
  files: FileManager[];
  constructor(data?: TenantLeaseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TenantLease`.
   */
  public static getModelName() {
    return "TenantLease";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TenantLease for dynamic purposes.
  **/
  public static factory(data: TenantLeaseInterface): TenantLease{
    return new TenantLease(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TenantLease',
      plural: 'TenantLeases',
      path: 'TenantLeases',
      idName: 'id',
      properties: {
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "tenant_id": {
          name: 'tenant_id',
          type: 'number'
        },
        "tenant_type": {
          name: 'tenant_type',
          type: 'string'
        },
        "exit_step": {
          name: 'exit_step',
          type: 'number',
          default: 0
        },
        "rejection_reason": {
          name: 'rejection_reason',
          type: 'string'
        },
        "application_date": {
          name: 'application_date',
          type: 'Date'
        },
        "application_approval_date": {
          name: 'application_approval_date',
          type: 'Date'
        },
        "exit_type": {
          name: 'exit_type',
          type: 'string'
        },
        "exit_date": {
          name: 'exit_date',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "tenant_lease_id": {
          name: 'tenant_lease_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
        tenant: {
          name: 'tenant',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        userProfile: {
          name: 'userProfile',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        leaseUnit: {
          name: 'leaseUnit',
          type: 'TenantUnit',
          model: 'TenantUnit',
          relationType: 'belongsTo',
                  keyFrom: 'tenant_id',
          keyTo: 'id'
        },
        tenantUnit: {
          name: 'tenantUnit',
          type: 'TenantUnit',
          model: 'TenantUnit',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        propertyUnit: {
          name: 'propertyUnit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        files: {
          name: 'files',
          type: 'FileManager[]',
          model: 'FileManager',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'model_item_id'
        },
      }
    }
  }
}
